import { Link } from "react-router-dom";

export function LegalShell({ title, updated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="legal-page">
      <nav className="text-xs text-slate-400 mb-4">
        <Link to="/" className="hover:text-emerald-600">Ana Sayfa</Link> <span className="mx-1">/</span> <span className="text-slate-500">{title}</span>
      </nav>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">{title}</h1>
      {updated && <p className="text-sm text-slate-400 mt-2">Son güncelleme: {updated}</p>}
      <div className="mt-8 space-y-5 text-slate-600 leading-relaxed text-[15px] [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-8 [&_h2]:mb-1 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_strong]:text-slate-800">
        {children}
      </div>
    </div>
  );
}
